import React from "react";
import { Alert, ButtonProps } from "@heroui/react";

interface HeroAlertProps {
  title?: React.ReactNode;
  icon?: React.ReactNode;
  description?: React.ReactNode;
  color?:
    | "default"
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "danger";
  variant?: "solid" | "bordered" | "flat" | "faded";
  radius?: "none" | "sm" | "md" | "lg" | "full";
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  isVisible?: boolean;
  isClosable?: boolean;
  hideIcon?: boolean;
  hideIconWrapper?: boolean;
  closeButtonProps?: ButtonProps;
  onClose?: () => void;
  onVisibleChange?: (isVisible: boolean) => void;
  className?: string;
}

/**
 *
 * @param param0 title, icon, description, color, variant, radius, startContent, endContent, isVisible, isClosable, hideIcon, hideIconWrapper, closeButtonProps, onClose, onVisibleChange
 * @returns NextUI Alert
 */
const HeroAlert: React.FC<HeroAlertProps> = ({
  title,
  icon,
  description,
  color = "default",
  variant = "flat",
  radius = "md",
  startContent,
  endContent,
  isVisible,
  isClosable = false,
  hideIcon = false,
  hideIconWrapper = false,
  closeButtonProps,
  onClose,
  onVisibleChange,
  className,
}) => {
  return (
    <Alert
      title={title}
      icon={icon}
      description={description}
      color={color}
      variant={variant}
      radius={radius}
      startContent={startContent}
      endContent={endContent}
      isVisible={isVisible}
      isClosable={isClosable}
      hideIcon={hideIcon}
      hideIconWrapper={hideIconWrapper}
      closeButtonProps={closeButtonProps}
      onClose={onClose}
      onVisibleChange={onVisibleChange}
      className={className}
    />
  );
};

export default HeroAlert;
